import { Header, Footer } from '@/components/Layout'
import {
  HeroSection,
  AboutSection,
  ServicesSection,
  StatsBarSection,
  PortfolioSection,
  ProcessSection,
  ReviewsSection,
  PricingSection,
  FAQSection,
  BlogSection,
  ContactSection,
} from '@/components/Sections'

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <div id="about">
          <AboutSection />
        </div>
        <div id="services">
          <ServicesSection />
        </div>
        <StatsBarSection />
        <div id="portfolio">
          <PortfolioSection />
        </div>
        <div id="process">
          <ProcessSection />
        </div>
        <div id="reviews">
          <ReviewsSection />
        </div>
        <div id="pricing">
          <PricingSection />
        </div>
        <div id="faq">
          <FAQSection />
        </div>
        <div id="blog">
          <BlogSection />
        </div>
        <div id="contact">
          <ContactSection />
        </div>
      </main>
      <Footer />
    </div>
  )
}
